import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  companySettingsSelector,
  formatSettingsSelector,
  instrumentsSettingsSelector,
  selectedInstrumentsSettingsSelectorWrapper,
} from "../store/slice/settings";
import { templateSettingsSelector, colorBlindModeSelector } from "../store/slice/settings";
import { formatNumberBySettings } from "../utils";

/**
 *
 * @returns {import("../..").CompanySetting}}
 */
export const useCompanySettings = () => {
  const companySetting = useSelector(companySettingsSelector);
  const currencies = companySetting.currencies
    .map(c => ({ ...c, order: c.order || 0 }))
    .sort((a, b) => a.order - b.order);
  return { ...companySetting, currencies };
};

export const useInstrumentsSetting = () => useSelector(instrumentsSettingsSelector);

/**
 *
 * @returns {import("../..").IFormatSetting}}
 */
export const useFormatSetting = () => useSelector(formatSettingsSelector);

/**
 *
 * @returns {import("../..").TTemplate}
 */
export const useTemplateSetting = () => useSelector(templateSettingsSelector);

/**
 *
 * @returns {import("../..").IInstrument}
 */
export const useSelectedInstrument = () => {
  const format = useFormatSetting();
  const selectedInstrumentsSettingsSelector = useMemo(selectedInstrumentsSettingsSelectorWrapper, []);
  const selectedInstrumentSettings = useSelector(selectedInstrumentsSettingsSelector);

  const formatNumber = (value, options = {}) => {
    return formatNumberBySettings(value, {
      ...format,
      ...selectedInstrumentSettings,
      ...options,
      decimalDigits: options.decimalDigits ?? selectedInstrumentSettings.decimalDigits ?? format.decimalDigits,
    });
  };
  return [selectedInstrumentSettings, { formatNumber }];
};

export const useColorBlindMode = () => useSelector(colorBlindModeSelector);
